module.exports = __webpack_public_path__ + "img/MENU.996819b8.svg";